/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_ExpandInputs */

const en_case_section_expand = /** @type {(inputs: Case_Section_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand section`)
};

const pt_br2_case_section_expand = /** @type {(inputs: Case_Section_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir seção`)
};

/**
* | output |
* | --- |
* | "Expand section" |
*
* @param {Case_Section_ExpandInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_expand = /** @type {((inputs?: Case_Section_ExpandInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_ExpandInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_expand(inputs)
	return pt_br2_case_section_expand(inputs)
});